import { render, staticRenderFns } from "./CreateThirdParty.vue?vue&type=template&id=3b8c6495&"
import script from "./CreateThirdParty.vue?vue&type=script&lang=js&"
export * from "./CreateThirdParty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports